import React from 'react';
import { PageHero } from '../components/PageHero';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { certificationsData } from '../data/certifications';
import { CertificationCard } from '../components/CertificationCard';
import { PartnerCTA } from '../components/PartnerCTA';
export function CertificationsPage() {
  return <>
      <PageHero label="About Us" title="Certifications & Accreditations" subtitle="Our commitment to quality, security, and environmental standards is verified by leading accreditation bodies." data-id="element-571" />

      <Breadcrumbs items={[{
      label: 'About Us',
      to: '/about'
    }, {
      label: 'Certifications'
    }]} data-id="element-572" />

      {/* Summary Cards Section */}
      <section className="bg-slate-50 py-24 border-b border-steel-200" data-id="element-573">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-574">
          <div className="mb-12" data-id="element-575">
            <h2 className="text-3xl font-bold text-navy-900 mb-4" data-id="element-576">
              Key certificates & accreditations
            </h2>
            <p className="text-lg text-steel-600" data-id="element-577">
              A quick overview of our primary certifications and memberships.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-578">
            {certificationsData.map(card => <CertificationCard key={card.id} card={card} data-id="element-579" />)}
          </div>
        </div>
      </section>

      <PartnerCTA data-id="element-580" />
    </>;
}